module.exports = __webpack_public_path__ + "img/bg.952ac781.svg";